/**
 * Side-effect imports: global @calendly/ui tokens before the pack module graph.
 * Not a pack entry — imported from webpack/entry.mjs only.
 *
 * bare-button CSS must load before Button (which extends unstyledButtonBase).
 * Webpack dedupes the bare-button module when the pack imports it again.
 */
import '@calendly/ui/body-styles'
import '@calendly/ui/components/bare-button'

const {
  reconcilePublisherStyleLayers,
  scheduleReconcilePublisherStyleLayers,
  startStyleLayerObserver,
} = require('../webpack/style-layer-markers.cjs')

if (typeof document !== 'undefined') {
  reconcilePublisherStyleLayers()
  scheduleReconcilePublisherStyleLayers()
  startStyleLayerObserver()

  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(reconcilePublisherStyleLayers)
  }

  // Late host/shared @calendly/ui chunks often run after the first microtask.
  setTimeout(reconcilePublisherStyleLayers, 0)
  setTimeout(reconcilePublisherStyleLayers, 250)
}
